module.exports = __webpack_public_path__ + "img/07.7f459b51.jpg";